import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

(function (window, document, $) {

    jQuery(document).ready(function($) {

        // configure Swiper to use modules
        Swiper.use([Navigation, Pagination, Autoplay]);

        // Swiper slider =================================================================================================

        function getOverviewSliderSettings() {
            var settings = {
                // Optional parameters
                direction: 'horizontal',
                loop: false,
                speed: 300,
                spaceBetween: 15,
                slidesPerView: 1.2,
                //freeMode: true,
                //freeModeMomentumRatio: 0.7,
                //freeModeMomentumVelocityRatio: 0.7,
                breakpoints: {
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 32,
                    },
                    768: {
                        slidesPerView: 2.2,
                        spaceBetween: 32,
                    }
                },
    
                navigation: {
                    nextEl: '.wpg-wdp-overview-slider-next',
                    prevEl: '.wpg-wdp-overview-slider-prev',
                },

                pagination: {
                    el: '.wpg-wdp-overview-slider-pagination',
                    type: 'bullets',
                    clickable: true,
                },
            };

            return settings;
        }

        var overviewSlider = new Swiper ('.wpg-wdp-overview-slider-container', getOverviewSliderSettings());

        /* Init Logged in overview sliders 
        $(document).on('init-loggedin-slider', function () {
            var loggedInOverviewSlider = new Swiper ('.loggedin-wpg-wdp-overview-slider-container', getOverviewSliderSettings());
        });*/

        // Init theme slider on overview page
        var themeSlider = new Swiper ('.wpg-wdp-theme-slider-container', {
            direction: 'horizontal',
            loop: false,
            speed: 300,
            spaceBetween: 15,
            slidesPerView: 2.5,
            breakpoints: {
                400: {
                    slidesPerView: 3.5,
                    spaceBetween: 15,
                },
                576: {
                    slidesPerView: 3.5,
                    spaceBetween: 15,
                },
                768: {
                    slidesPerView: 4.3,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 6,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 7,
                    spaceBetween: 30,
                },
            },

            navigation: {
                nextEl: '.wpg-wdp-overview-slider-next',
                prevEl: '.wpg-wdp-overview-slider-prev',
            },
        });


        // Init theme button slider on all digital products page
        var themeButtonSlider = new Swiper ('.wpg-wdp-theme-slider-buttons-container', {
            direction: 'horizontal',
            loop: false,
            speed: 300,
            spaceBetween: 8,
            slidesPerView: 'auto',
            breakpoints: {
                992: {
                    enabled: false,
                },
                768: {
                    enabled: true,
                }
            },
        });


        // Init other products slider for block on single-digitalproduct
        var otherProductsSlider = new Swiper ('.wpg-wdp-product-block-slider-container', {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            speed: 300,
            spaceBetween: 15,
            slidesPerView: 1.2,
            //freeMode: true,
            //freeModeMomentumRatio: 0.7,
            //freeModeMomentumVelocityRatio: 0.7,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                }
            },

            navigation: {
                nextEl: '.wpg-wdp-product-block-slider-next',
                prevEl: '.wpg-wdp-product-block-slider-prev',
            },

            pagination: {
                el: '.wpg-wdp-product-block-slider-pagination',
                type: 'bullets',
                clickable: true,
            },
        });

        // wpg-wdp-top-bar-usps slider
        var topBarSwiper = new Swiper ('.wpg-wdp-top-bar-usps', {
            direction: 'horizontal',
            loop: true,
            speed: 300,
            allowTouchMove: false,
            autoplay: {
                delay: 5000,
            },
            enabled: true,
            spaceBetween: 30,
            slidesPerView: 1,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    enabled: false,
                },
                768: {
                    slidesPerView: 2,
                    enabled: true,
                }
            },
        });

        // Init comments slider for block on single-digitalproduct
        var commentsSlider = new Swiper ('.wpg-wdp-product-block-comments-slider-container', {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            speed: 300,
            spaceBetween: 15,
            slidesPerView: 1.2,
            //freeMode: true,
            //freeModeMomentumRatio: 0.7,
            //freeModeMomentumVelocityRatio: 0.7,
            breakpoints: {
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                }
            },

            navigation: {
                nextEl: '.wpg-wdp-product-block-slider-next',
                prevEl: '.wpg-wdp-product-block-slider-prev',
            },

            pagination: {
                el: '.wpg-wdp-product-block-slider-pagination',
                type: 'bullets',
                clickable: true,
            },
        });

        var quoteSwiper = new Swiper ('.wpg-wdp-product-quote-container', {
            // Optional parameters
            direction: 'horizontal',
            loop: true,

            autoplay: {
                delay: 5000,
            },

            // If we need pagination
            pagination: {
              el: '.wpg-wdp-product-quote-pagination',
              clickable: true,
            },
        });

        var centerInsufficientSlides = false;
        if ($('.wpg-wdp-overview').length) {
            centerInsufficientSlides = true;
        }

        var anchorSwiper = new Swiper ('.wpg-wdp-product-anchor-slider', {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            centerInsufficientSlides: centerInsufficientSlides
        });
    });
}(window, document, jQuery));